"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnDkNok = exports.EnDkSek = exports.EnDkEur = exports.EnDkUsd = exports.EnDkDkk = void 0;
class EnDkDkk {
    constructor() {
        this.locale = "en-dk";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "DKK",
            symbol: "DKK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnDkDkk = EnDkDkk;
class EnDkUsd {
    constructor() {
        this.locale = "en-dk";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnDkUsd = EnDkUsd;
class EnDkEur {
    constructor() {
        this.locale = "en-dk";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnDkEur = EnDkEur;
class EnDkSek {
    constructor() {
        this.locale = "en-dk";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "SEK",
            symbol: "SEK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnDkSek = EnDkSek;
class EnDkNok {
    constructor() {
        this.locale = "en-dk";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "NOK",
            symbol: "NOK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnDkNok = EnDkNok;
